
  import { Component, Prop, Vue } from 'vue-property-decorator';
  // @ts-ignore
  import VueCircle from 'vue2-circle-progress/src/index.vue';
  // @ts-ignore
  import VueMq from 'vue-mq';
  import Stat from './Stat.vue';

  Vue.use(VueMq, {
    breakpoints: {
      small: 768,
      lg: Infinity,
    },
  });

  @Component({
    components: { VueCircle, Stat },
  })
  export default class Progress extends Vue {
    @Prop({ required: true }) readonly name!: string;

    @Prop({ required: true }) readonly color!: string;

    @Prop({ default: 0 }) readonly progress!: number;

    @Prop({ required: true }) readonly total!: number;
  }
